import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col, Button, Stack, Spinner} from "react-bootstrap"
import MessageModal from "./MessageModal"
import doValidations from "../utils/doValidations";
import WriteData from "../utils/WriteData";
import "./Form.css"

const AssessmentFormCRUD = (props) => {

    console.log("in AssessmentFormCrud")
    const setDataChange = props.setDataChange // descructure for useEffect
    // console.log("props.setRefresh=", props.setRefresh)
    // console.log("AssessmentFormCrud formData= ", props.formData)
    console.log("AssessmentFormCRUD sectionValue = ", props.assessmentId)

    const REACT_APP_ENDPOINT_TRAINING_MAINT=process.env.REACT_APP_ENDPOINT_TRAINING_MAINT;
    let apiPath = ''

    const [dbWorkComplete, setDbWorkComplete] = useState(true);
    const [postDelete, setPostDelete] = useState(false);  //to prevent a preLoadValues load in rerender after record deletion.

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [titleMessage, setTitleMessage] = useState(null)
    const [validationMessage, setValidationMessage] = useState(null)

    const [deleteWarning, setDeleteWarning] = useState(false)
    const [validationLookup, setValidationLookup] = useState(false)


    let preloadValues = {}

    const onSubmit = async data => {
        console.log(data);
        setDbWorkComplete(false)
        console.log ("formAction=", getValues("formAction"))
        let passValidation = true
        if (getValues("formAction") === "insert" || getValues("formAction") === "update") {
            passValidation = await doValidations("AssessmentFormCRUD", getValues("formAction"), dirtyFields, data, props.formData, setValidationMessage)
        }
        if (passValidation) {
            if (getValues("formAction") === "insert") {
                apiPath=REACT_APP_ENDPOINT_TRAINING_MAINT + "/assessment_insert"
                WriteData(apiPath, data, "post", setDbWorkComplete)
            }
            else if (getValues("formAction") === "update") {
                apiPath=REACT_APP_ENDPOINT_TRAINING_MAINT + "/assessment_update"
                WriteData(apiPath, data, "put", setDbWorkComplete, props.assessmentId, props.refresh, props.setRefresh)
                props.handleOuterClose()
            }
            else if (getValues("formAction") === "delete") {
                apiPath=REACT_APP_ENDPOINT_TRAINING_MAINT + "/assessment_update"
                WriteData(apiPath, data, "delete", setDbWorkComplete, props.assessmentId,  props.refresh, props.setRefresh)
                setPostDelete(true)
                setDbWorkComplete(true)
                props.handleOuterClose()
            }
            if (dbWorkComplete) {
                console.log ("back in AssessmentFormCrud dbWorkComplete")
                reset({
                    assessnebtId: "",
                    category: "",
                    sortKey: "",
                    name: "",
                    description: "",
                    assessnebtLink: "",
                    },
                    {
                        keepDefaultValue: true,
                    })
                props.setDataChange(false)
             }
        }
        else {
            console.log('validationMessage=', validationMessage)
            setTitleMessage("There's a data issue")
            setDbWorkComplete(true)
            setShow(true)
        }
    }

    // console.log("in to AssessmentFormCRUD dataChange= ", props.dataChange)

    if (props.CRUD === "ReadUpdateDelete" && !postDelete) {
         let formValues = props.formData.filter(obj => {
                return obj.assessment_id === props.assessmentId
        })
        console.log("AssessmentFormCRUD formValue= ", formValues)
        preloadValues = {
            assessmentId: formValues[0].assessment_id,
            category: formValues[0].category,
            sortKey: formValues[0].sort_key,
            name: formValues[0].name,
            description: formValues[0].description,
            assessmentLink: formValues[0].assessment_link,
            formAction: "read"  // form buttons set this value to 'update', 'insert', 'delete'
        }
    }
    else {
        preloadValues = {
            assessmentId: "",
            category: "",
            sortKey: "",
            name: "",
            description: "",
            assessmentLink: "",
            formAction: "read"  // form buttons set this value to 'update', 'insert', 'delete'
        }
        }

    const { register, handleSubmit, watch, getValues, setValue, reset, formState: {dirtyFields}} = useForm({
        defaultValues: preloadValues
    });

    // watch tracks user input
    watch ()

    useEffect(() => {
        const subscription = watch(() => setDataChange(true))
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch]);

    return (
    <div className="form-box">
    <Container fluid className="form-box">
        <MessageModal
            show={show}
            handleClose={handleClose}
            titleMessage={titleMessage}
            validationMessage={validationMessage}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
            <Col >
                <label className="label-format">Module*</label>
            </Col>
            <Col xs={9}>
                <input type="text" placeholder="Module name" className="input-format"
                {...register("category", {required: true})} />
            </Col>
            </Row>
            <br/>
            <Row>
            <Col >
                <label className="label-format">Sort Key*</label>
            </Col>
            <Col xs={9}>
                <input type="text" placeholder="Enter a sort key value to define the order of this item within the module" className="input-format"
                {...register("sortKey", {required: true })} />
            </Col>
            </Row>
            <br/>
            <Row >
            <Col >
                <label className="label-format">Assessment Name*</label>
            </Col>
            <Col xs={9}>
                <input type="text" placeholder="Name of the training assessment" className="input-format"
                {...register("name", {required: true})} />
            </Col>
            </Row>
            <br/>
            <br/>
            <Row >
            <Col >
                <label className="label-format">Description*</label>
            </Col>
            <Col xs={9}>
                <textarea placeholder="Enter a description of the assessment.  Two lines maximum"
                className="input-format"
                magin="normal"
                cols="30"
                rows="2"
                wrap="on"
                {...register("description", {required: true, maxLength: 192})} />
            </Col>
            </Row>
            <br/>
            <Row >
            <Col >
                <label className="label-format">Assessment Link*</label>
            </Col>
            <Col xs={9}>
                <input type="text" placeholder="Paste assessment link here" className="input-format"
                {...register("assessmentLink", {required: true })} />
            </Col>
            </Row>
            <br/>

            {/* conditionally render CRUD buttons based on form mode. */}

            <Row className="justify-content-center">


                    <>
                    <Stack direction="horizontal" gap={3} className="d-flex justify-content-center">
                    {(validationLookup === false) &&
                    <Button className="yellow-button"
                        onClick={() => {
                            window.open(getValues("assessmentLink"), "_blank")
                            setValidationLookup(true)
                         }}
                    >Validate</Button>
                    }
                    {(validationLookup === true) &&
                        <Button className="blue-button"
                        onClick={() => {
                            window.open(getValues("assessmentLink"), "_blank")
                            setValidationLookup(true)
                         }}
                    >Validate</Button>
                    }
                    {(props.CRUD === "ReadUpdateDelete") &&
                    <>
                    <Button className="blue-button"
                        onClick={() => {
                            if (validationLookup === false) {
                                setTitleMessage ("Please validate the Assessment Link")
                                setValidationMessage(" ")
                                setShow(true)
                            }
                            else {
                                setValue("formAction", "update")
                                handleSubmit(onSubmit)()
                            }
                        }}
                    >Save</Button>
                    <Button className="blue-button"
                        onClick={() => {
                            if (deleteWarning === false) {
                                setTitleMessage("You are about to delete a Training Assessment")

                                setValidationMessage("This will immedediately remove this video from our training page. "
                                + "If you're sure you want to make this change, please click on the Delete button a second time."
                                )
                                setShow(true)
                                setDeleteWarning(true)
                            }
                            else {
                                setValue("formAction", "delete")
                                handleSubmit(onSubmit)()
                            }
                    }}
                    >Delete</Button>
                    </>
                    }
                    {(props.CRUD === "Add") &&
                    <Button className="blue-button"
                            onClick={() => {
                                if (validationLookup === false) {
                                setTitleMessage ("Please validate the Assessment Link")
                                setValidationMessage(" ")
                                setShow(true)
                            }
                            else {
                                setValue("formAction", "insert")
                                setValidationLookup(false)
                                handleSubmit(onSubmit)()
                            }
                         }}
                    >Save</Button>
                    }
                    </Stack>
                    </>
                    <p>* Required field</p>
            </Row>
            {(!dbWorkComplete) &&
                    <div>
                    <Spinner animation="border" role="status" style={{color: "#00447c"}}>
                    <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    </div>
            }
        </form>
    </Container>
    </div>

    )

}

export default AssessmentFormCRUD